<template src='./nations.html'></template>

<script>
import {API_URL} from '@/main'
import axios from "axios"
import router from '@/router/index.js'

export default {
  name: "Nations",
  data() {
    return {
      current_id: null,
      currentPage: 1,
      form_data: {},
      nations: [],
      nations_fields: [
        { label: '', key: 'id', sortable: false, tdStyle: { width: '0%' } },
        { label: 'Acronimo', key: 'acronym', sortable: true, tdStyle: { width: '10%' } },
        { label: 'Nome nazione', key: 'nation', sortable: true, tdStyle: { width: '85%' } },
        { label: 'Attiva', key: 'active', sortable: true, tdStyle: { width: '5%' } },
      ],
      perPage: 10,
      sortBy: '',
      sortDesc: false,
      total_rows: 0,
    }
  },
  watch: {
    currentPage: {
      handler(newPage, oldPage) {
    
        console.log(`Page changed from ${oldPage} to ${newPage}`)
      }
    }
  },   
  computed: {
    paginatedNations() {

      return this.nations
    },
    totalRows() {this.totalRows = this.totalRows / this.perPage

      return this.nations.length
    }
  },  
  mounted() {

    this.loadNationsList()
  },
  methods: {
    cancelNation() {

      this.current_id = null
      this.form_data = {}
    },
    handlePageChange(page) {

      this.currentPage = page
      this.$nextTick(() => {
        
        this.loadNations()
      })
    },    
    async insertNation() {

      const url = API_URL+"geographic/NationsDetail/"
      const headers = {
        'User-ID': localStorage.getItem('User_id'),
        'token': localStorage.getItem('Token'),
      }
      const response = await axios.post(url, this.form_data, {headers: headers})
      this.cancelNation()
      this.loadNationsList()
    },
    async loadNationsList() {

      const url = API_URL + "geographic/NationsList/"
      const headers = {
        'User-ID': localStorage.getItem('User_id'),
        'token': localStorage.getItem('Token'),
      }

      try {

        const response = await axios.get(url, {headers: headers})
        this.nations = response.data.map(nation => ({
          acronym: nation.acronym,
          active: nation.active,
          id: nation.id,
          nation: nation.nation,
        }))
        this.total_rows = this.nations.length
      } 
      catch(error) {
      
        console.log('Failed to load nations list:', error)
      }      
    },
    onPageChange(page) {
      
      this.currentPage = page
      this.$nextTick(() => {
        
        this.loadNationsList()
      })
    },    
    onPerPageChange(newPerPage) {
    
      this.perPage = newPerPage
      this.currentPage = 1
      this.loadNationsList()
    },
    onSortChanged(ctx) {
      
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
    },    
    async selectNation(row) {

      this.current_id = row.id
      const url = API_URL+"geographic/NationsDetail/"+row.id+"/"
      const headers = {
        'User-ID': localStorage.getItem('User_id'),
        'token': localStorage.getItem('Token'),
      }
      const response = await axios.get(url, {headers: headers})
      this.form_data = response.data
    },    
    async updateNation() {

      const url = API_URL+"geographic/NationsDetail/"+this.current_id+"/"
      const headers = {
        'User-ID': localStorage.getItem('User_id'),
        'token': localStorage.getItem('Token'),
      }
      const response = await axios.patch(url, this.form_data, {headers: headers})
      this.cancelNation()
      this.loadNationsList()
    },
  },
}

</script>